import { useState } from 'react';

import ResourceListToggle from './ResourceListToggle';

interface ResourceListProps {
    children: React.ReactNode,
    toggleElement?: React.ReactNode,
    defaultCollapsed?: boolean,
    onToggle?: (expanded: boolean) => void
}

const ResourceList = ({ children, toggleElement, defaultCollapsed, onToggle }: ResourceListProps) => {
    const [collapsed, setCollapsed] = useState(defaultCollapsed || false);

    const handleToggleClick = () => {
        setCollapsed(prevState => !prevState);

        onToggle?.(collapsed);
    }

    return (
        <div className="resource-list-holder">
            {
                toggleElement ? (
                    <ResourceListToggle collapsed={collapsed} onClick={handleToggleClick}>{ toggleElement }</ResourceListToggle>
                ) : null
            }

            {
                !collapsed ? (
                    <div className="resource-list">
                        { children }
                    </div>
                ) : null
            }
        </div>
    );
}

export default ResourceList;
